module.exports = __webpack_public_path__ + "img/5.bfc8f489.png";